import UI from "./elements.module"

// __class HeaderModule {
// 	private ui = new UI()
// 	private headerFixTimer: number | null = null
// 	private headerAnim: Animation | null = null
// 	private headerSpacer: HTMLElement | null = null
// 	private observer: IntersectionObserver | null = null
// 	private boundTopCheck: (() => void) | null = null
// 	private boundPageShow: (() => void) | null = null

// 	constructor() { }

// 	addWatcherToHeaderOnScroll() {
// 		// intercept (observer target)
// 		let intercept = document.querySelector("[data-observer-intercept]") as HTMLElement | null
// 		if (!intercept) {
// 			intercept = document.createElement("div")
// 			intercept.setAttribute("data-observer-intercept", "")
// 			this.ui.header?.before(intercept)
// 		}
// 		this.ui.headerIntersect = intercept

// 		// spacer (layout placeholder) - MUST be in flow
// 		let spacer = document.querySelector("[data-header-spacer]") as HTMLElement | null
// 		if (!spacer) {
// 			spacer = document.createElement("div")
// 			spacer.setAttribute("data-header-spacer", "")
// 			spacer.style.height = "0px"
// 			spacer.style.width = "100%"
// 			spacer.style.pointerEvents = "none"
// 			spacer.style.position = "relative"
// 			this.ui.header?.before(spacer)
// 		}
// 		this.headerSpacer = spacer
// 	}

// 	setHeaderShadow() {
// 		const FIX_DELAY_MS = 1500
// 		const headerEl = this.ui.header as HTMLElement | null
// 		const sentinelEl = this.ui.headerIntersect as HTMLElement | null
// 		const spacerEl = this.headerSpacer as HTMLElement | null
// 		if (!headerEl || !sentinelEl || !spacerEl) return

// 		const setSpacerHeight = (px: number) => {
// 			spacerEl.style.height = `${Math.max(0, Math.ceil(px))}px`
// 		}

// 		const getScrollTop = () =>
// 			window.scrollY ||
// 			document.documentElement.scrollTop ||
// 			document.body.scrollTop ||
// 			0

// 		const reset = () => {
// 			this.headerAnim?.cancel()
// 			this.headerAnim = null

// 			if (this.headerFixTimer != null) {
// 				clearTimeout(this.headerFixTimer)
// 				this.headerFixTimer = null
// 			}

// 			headerEl.removeAttribute("data-header-box-shadow")
// 			headerEl.removeAttribute("data-header-fixed-ready")
// 			headerEl.removeAttribute("data-header-fixed")

// 			setSpacerHeight(0)
// 		}

// 		// If we restore state on load, don't run the delayed animation again
// 		let hasInitialFixedState = false

// 		const applyInitialStateIfNeeded = () => {
// 			if (getScrollTop() <= 0) return

// 			const headerH = headerEl.getBoundingClientRect().height
// 			setSpacerHeight(headerH)

// 			headerEl.setAttribute("data-header-box-shadow", "")
// 			headerEl.setAttribute("data-header-fixed", "")
// 			headerEl.setAttribute("data-header-fixed-ready", "")

// 			hasInitialFixedState = true
// 		}

// 		const startFixedAnimation = () => {
// 			if (hasInitialFixedState) return
// 			if (this.headerFixTimer != null || headerEl.hasAttribute("data-header-fixed")) return

// 			this.headerFixTimer = window.setTimeout(() => {
// 				this.headerAnim?.cancel()
// 				this.headerAnim = null

// 				const headerH = headerEl.getBoundingClientRect().height
// 				setSpacerHeight(headerH)

// 				// Ensure the CSS start state is active (translateY(-100%))
// 				headerEl.removeAttribute("data-header-fixed-ready")
// 				headerEl.setAttribute("data-header-fixed", "")

// 				// Force style commit before WAAPI
// 				void headerEl.getBoundingClientRect()

// 				// Animate from hidden -> visible, but DO NOT touch inline transform
// 				this.headerAnim = headerEl.animate(
// 					[{ transform: "translateY(-100%)" }, { transform: "translateY(0)" }],
// 					{ duration: 320, easing: "ease", fill: "forwards" }
// 				)

// 				this.headerAnim.onfinish = () => {
// 					headerEl.setAttribute("data-header-fixed-ready", "")
// 					this.headerAnim = null
// 				}

// 				this.headerFixTimer = null
// 			}, FIX_DELAY_MS)
// 		}

// 		const applyShadowState = () => {
// 			headerEl.setAttribute("data-header-box-shadow", "")
// 			startFixedAnimation()
// 		}

// 		// add safety net only once
// 		if (!this.boundTopCheck) {
// 			this.boundTopCheck = () => {
// 				if (getScrollTop() <= 0) reset()
// 			}
// 			window.addEventListener("scroll", this.boundTopCheck, { passive: true })
// 		}

// 		// Apply initial state now and after Safari restores scroll
// 		applyInitialStateIfNeeded()

// 		requestAnimationFrame(() => {
// 			requestAnimationFrame(() => applyInitialStateIfNeeded())
// 		})

// 		this.observer?.disconnect()

// 		const onIntersect: IntersectionObserverCallback = (entries) => {
// 			for (const entry of entries) {
// 				const y = getScrollTop()

// 				// Only reset when truly at the top
// 				if (entry.isIntersecting && y <= 0) {
// 					hasInitialFixedState = false
// 					reset()
// 					continue
// 				}

// 				// Normal scroll-down behavior
// 				if (!entry.isIntersecting) {
// 					applyShadowState()
// 				}
// 			}
// 		}

// 		this.observer = new IntersectionObserver(onIntersect, {
// 			threshold: 0,
// 			rootMargin: "8px 0px 0px 0px",
// 		})

// 		// Safari scroll restoration happens after script execution.
// 		// Delay observing so we don't get the "early intersecting => flicker" pass.
// 		const startObserving = () => {
// 			requestAnimationFrame(() => {
// 				requestAnimationFrame(() => {
// 					// If we're not at top after restoration, lock the initial state once
// 					applyInitialStateIfNeeded()
// 					this.observer?.observe(sentinelEl)
// 				})
// 			})
// 		}

// 		// Start once now (Chrome/Firefox fine; Safari benefits)
// 		startObserving()

// 		// And also on pageshow (Safari bfcache / refresh quirks)
// 		if (!this.boundPageShow) {
// 			this.boundPageShow = () => startObserving()
// 			window.addEventListener("pageshow", this.boundPageShow)
// 		}

// 	}


// 	setMainElementToMatchHeader() { }

// 	addBoxShadowWhenNotPrimaryBg() {
// 		if (!this.ui.heroSection?.getAttribute("class")?.includes("bg-")) {
// 			this.ui.header?.setAttribute("data-header-box-shadow", "")
// 		}
// 	}
// }

class HeaderModule {
    private ui = new UI()
    private slideTimeout: ReturnType<typeof setTimeout> | null = null;
    private PERSIST_KEY = 'header-is-fixed';

    constructor() {
        this.checkPersistentHeaderState();
    }

    private checkPersistentHeaderState() {
        const header = this.ui.header;
        if (!header) return;

        const isStickySlide = header.getAttribute('data-sticky') === 'slide';
        const wasFixed = sessionStorage.getItem(this.PERSIST_KEY) === 'true';
        const isNotAtTop = window.scrollY > 0;

        if (isStickySlide && wasFixed && isNotAtTop) {
            header.setAttribute("data-header-box-shadow", "");
            header.classList.add("is-sliding-in");
            header.setAttribute("data-header-persist", "");
        }
    }

    addWatcherToHeaderOnScroll() {
        const scrollableWatcher = document.createElement("div")
        scrollableWatcher.setAttribute('data-observer-intercept', '')
        scrollableWatcher.style.height = "1px"
        scrollableWatcher.style.marginTop = "-1px"
        this.ui.header?.before(scrollableWatcher)
        this.ui.headerIntersect = document.querySelector("[data-observer-intercept]")
    }

    setHeaderShadow() {
        const onIntersect = (entries: IntersectionObserverEntry[]) => {
            entries.forEach(entry => {
                const header = this.ui.header;
                if (!header) return;

                const isStickySlide = header.getAttribute('data-sticky') === 'slide';
                const shouldStick = !entry.isIntersecting;
                const delayAttr = header.getAttribute('data-sticky-delay');
                const delay = delayAttr ? parseInt(delayAttr, 10) : 5000;

                if (this.slideTimeout) {
                    clearTimeout(this.slideTimeout);
                    this.slideTimeout = null;
                }

                if (shouldStick) {
                    if (isStickySlide) {
                        const wasFixed = sessionStorage.getItem(this.PERSIST_KEY) === 'true';

                        if (wasFixed) {
                            header.setAttribute("data-header-box-shadow", "");
                            header.classList.add("is-sliding-in");
                            header.setAttribute("data-header-persist", "");
                        } else {
                            this.slideTimeout = setTimeout(() => {
                                header.setAttribute("data-header-box-shadow", "");
                                header.classList.add("is-sliding-in");
                                sessionStorage.setItem(this.PERSIST_KEY, 'true');
                            }, delay);
                        }
                    } else if (header.hasAttribute('data-sticky')) {
                        header.setAttribute("data-header-box-shadow", "");
                    }
                } else {
                    header.removeAttribute("data-header-box-shadow");
                    
                    if (isStickySlide) {
                        header.classList.remove("is-sliding-in");
                        header.removeAttribute("data-header-persist");
                        sessionStorage.removeItem(this.PERSIST_KEY);
                    }
                }
            });
        }

        const observer = new IntersectionObserver(onIntersect, { threshold: [0], rootMargin: "0px" })
        observer.observe((this.ui.headerIntersect as HTMLElement))
    }

    addBoxShadowWhenNotPrimaryBg() {
        if (!this.ui.heroSection?.getAttribute('class')?.includes('bg-')) {
            if (this.ui.header) this.ui.header.style.boxShadow = 'var(--shadow-md)';
        }
    }
}

export default HeaderModule
